import React from 'react';
import { ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { product } from '../data/landing';
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-83" data-mp="9ktefowaq4ya">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 pb-16 pt-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-84" data-mp="9ll98xi2jyni">
        <div data-id="element-85" data-mp="4jvup7vn12uo">
          <p className="font-sans text-base font-semibold text-teal" data-id="element-86" data-mp="129h5y27n1qka">
            Para mujeres de 65 años o más
          </p>
          <h1 className="mt-4 font-serif text-4xl font-semibold leading-[1.1] text-ink sm:text-5xl lg:text-[3.5rem]" data-id="element-87" data-mp="xa4ibf8y0fgn">
            Dígale adiós a la rigidez matutina:{' '}
            <span className="text-teal" data-id="element-88" data-mp="nc85mj0cxcgf">recupere su movilidad en 7 días</span>{' '}
            con el Protocolo de Inflamación Silenciosa.
          </h1>
          <h2 className="mt-6 max-w-readable font-sans text-xl leading-relaxed text-inkSoft sm:text-2xl" data-id="element-89" data-mp="3d33gp3txj3ne">
            El método natural diseñado específicamente para mujeres de 65+ que
            desean volver a moverse sin dolor, sin fármacos pesados y sin
            cirugías.
          </h2>

          <div className="mt-10" data-id="element-90" data-mp="3o73mw4xwji4w">
            <CtaButton className="w-full sm:w-auto" data-id="element-91" data-mp="3o59cvlo65afl" />
            <p className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 font-sans text-base text-inkSoft" data-id="element-92" data-mp="399jm7a81g94j">
              <span className="inline-flex items-center gap-2" data-id="element-93" data-mp="3e7uydrlt2vpx">
                <ClockIcon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-94" data-mp="30hrgtdxvfq6t" />
                Acceso inmediato tras la compra
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-95" data-mp="35a2hij0frg0f">
                <ShieldCheckIcon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-96" data-mp="2qkwkn1p2m1vp" />
                Pago seguro y cifrado
              </span>
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-97" data-mp="2hl9s75ebk6es">
          <div className="overflow-hidden rounded-2xl bg-teal-soft ring-1 ring-teal/15" data-id="element-98" data-mp="2lkij82hz5q6n">
            <img src={product.mockup} alt="El Protocolo de Inflamación Silenciosa mostrado en tableta, computadora y teléfono" className="h-full w-full object-cover" data-id="element-99" data-mp="s1rpyhl8dur4" />
          </div>
          <p className="mt-4 text-center font-sans text-base text-inkSoft lg:text-left" data-id="element-100" data-mp="id9ri70fbzqn">
            Léalo desde su teléfono, tableta o computadora. Letra grande, sin
            complicaciones.
          </p>
        </div>
      </div>
    </header>;
}